import React, { PureComponent } from 'react';
import { Search } from 'semantic-ui-react';
import style from './styles/style.module.css';

export default class DLAutoComplete extends PureComponent {
    render() {
        const { value, label, results } = this.props;
        const inlineStyle = { ...this.props.style };

        return (
            <div className={ `semantic-wrapper ${ style.semanticAutoComplete } ${ this.props.className }` }
            data-full-width={ this.props.fullWidth }
            style={ inlineStyle }>
                { label &&
                    <label>{ label }</label>
                }
                <Search className={ `${ style.semanticSearch }` }
                value={ value }
                results={ results }
                type={ this.props.type }
                autoFocus={ this.props.autoFocus }
                open={ this.props.open }
                onSearchChange={ this.props.onChange }
                onFocus={ this.props.onFocus }
                onBlur={ this.props.onBlur }
                onResultSelect={ this.props.onResultSelect }
                required={ this.props.required }
                placeholder={ this.props.placeholder }
                icon={ null }
                maxLength={ this.props.maxLength } />
                { this.props.hintMessage &&
                    <p className='hint-message'>{ this.props.hintMessage }</p>
                }
                <p className='error-message'>{ this.props.error }</p>
            </div>
        );
    }
}

DLAutoComplete.defaultProps = {
    className: '',
    style: {},
    onChange: ()=>{},
    onFocus: ()=>{},
    onBlur: ()=>{},
    onResultSelect: ()=>{},
};
